module.exports = __webpack_public_path__ + "img/baby.257295c7.png";